import { all, fork } from 'redux-saga/effects';
import { playSaga } from './play';
import { windowSaga } from './window';
import { videoSaga } from './video';
import { containerSaga } from './container';

export default function* playerSaga() {
  yield all([fork(videoSaga), fork(playSaga), fork(windowSaga), fork(containerSaga)]);
}
